export const DASHBOARD_REPORT = {
  IncomeSummary: '/report/dashboard/income-summary',
  IncomeDetails: '/report/dashboard/income-details',
  PaymentSummary: '/report/payment-analysis/summary',
};
